import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { components, palette, typography } from '@utriper/core-ui';

import overrides from './overrides';

// palette, typography and components are @utriper/core-ui's, generated from the design system's tokens.json
// (com.utriper.core-ui/design-system, `npm run gen:theme`). Only what is this app's own stays here: the legacy
// `overrides` block, which adaptV4Theme turns into `components`, and `inputs`.
const v4 = adaptV4Theme({
    palette,
    // core-ui's h5 is uppercase ("grouped labels" in the design system). app's seven h5 usages are names,
    // emails and counters, and its own typography never had the transform, so it is opted out here.
    typography: { ...typography, h5: { ...typography.h5, textTransform: 'none' } },
    overrides,
    inputs: {
        minHeight: 104,
    },
});

export default createTheme({
    ...v4,
    // core-ui's component overrides travel with its palette (contained secondary buttons rest on a darker blue
    // for AA contrast). Merged over the v4 ones so both apply.
    components: deepmerge(v4.components, components),
});
